import { Injectable, Signal, computed, inject, signal } from '@angular/core';

import type { Property } from '@common/types';

import { ScopeService } from './scope.service';

@Injectable({ providedIn: 'root' })
export class AdminAccountService {
  private readonly scope = inject(ScopeService);

  private readonly override = signal<string | null>(null);

  readonly availableAccounts = computed<ReadonlyArray<Property>>(() => this.scope.scopeAccounts());

  readonly hasMultiple = computed<boolean>(() => this.availableAccounts().length > 1);

  readonly account: Signal<Property | null> = computed<Property | null>(() => {
    const available = this.availableAccounts();
    if (available.length === 0) return null;

    const overrideId = this.override();
    const overridden = overrideId ? available.find((a) => a.id === overrideId) : undefined;
    if (overridden) return overridden;

    const selected = this.scope.selectedAccount();
    if (selected && available.some((a) => a.id === selected.id)) return selected;

    return available[0];
  });

  readonly accountId = computed<string | null>(() => this.account()?.id ?? null);

  select(id: string): void {
    this.override.set(id);
  }

  isSelected(id: string): boolean {
    return this.accountId() === id;
  }

  accountById(id: string | null): Property | null {
    if (!id) return null;
    return this.scope.accounts.find((account) => account.id === id) ?? null;
  }
}
